import { ChangesTrackerDrawer } from '@carboncopyco/editor-ui';
import { memo } from 'react';
import { useEditorEdits } from '../context/EditorSdkProvider';
import { useEditorTool } from '../hooks/useEditorTool';

export const ChangesTrackerTool = memo(() => {
  const { edits } = useEditorEdits();
  const { isOpen, close } = useEditorTool('changeTracker');

  return (
    <ChangesTrackerDrawer
      open={isOpen}
      onClose={close}
      edits={edits}
    />
  );
});

ChangesTrackerTool.displayName = 'ChangesTrackerTool';
